export default "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAIAAACEAQMAAACAkWiiAAAAA1BMVEXn6eldvemGAAAADElEQVQYGWMYBWAAAAEIAAG6JZyTAAAAAElFTkSuQmCC"